<script>
import CommonConstants from '../../common/Constants';

import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Toolbar from 'primevue/toolbar';
import Dialog from 'primevue/dialog';
import GenericCustomMasterDataSelect from '../../components/generic/GenericCustomMasterDataSelect.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

import Service from '../../services/movement-instruction';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default{
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Toolbar, Dialog, Card, DataTable, Column,
    InputText,
    GenericCustomMasterDataAutocompleteV2, ResponsiveButton, GenericCustomMasterDataSelect
  },
  props: ['id', 'readOnly'],
  data(){
    return {
      submitted: false,
      analysisSampleDisabled: false,
      items: [],
      analysisSampledialogVisible: false,
      analysisSampleItem: {
        idRegistryAnalysisSampleReceiver: null,
        idRegistrySamplingPoint: null,
        numberofSamples: null,
        uoMCode: null,
        quantity: null
      }
    }
  },
  validations(){
    return {
      analysisSampleItem: {
        idRegistryAnalysisSampleReceiver: {required},
        idRegistrySamplingPoint: {required},
        numberofSamples: {required},
        uoMCode: {required},
        quantity: {required}
      }
    }
  },
  mounted(){
    if(this.id){
      this.loadData();
    }
  },
  computed: {
      constants(){
          return CommonConstants;
      },
      uiPermissions(){
        return this.$store.getters['security/uiPermissions'];
      }
  },
  methods: {
    reload(){
      this.loadData();
    },
    loadData(){
      let filters = [
        {
          operator: 'eq',
          value: this.id,
          property: 'IdMovementInstructionLot'
        }
      ];
      let params = {
          filter: JSON.stringify(filters),
      }

      Service.getAnalysisSample(params, response => {
        if(response.success){
          this.items = response.data;
        }
      });
    },
    submitSaveAnalysisSample(){
      this.submitted = true;
      if(!this.v$.$invalid){
        this.analysisSampleDisabled = true;
        if(this.analysisSampleItem.id){
          Service.updateAnalysisSample(this.analysisSampleItem, 
            response => {
              this.submitted = false;
              this.analysisSampleDisabled = false;
              if(response.success){
                this.loadData();
                this.analysisSampledialogVisible = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }else{
          Service.createAnalysisSample(this.analysisSampleItem, 
            response => {
              this.submitted = false;
              this.analysisSampleDisabled = false;
              if(response.success){
                this.loadData();
                this.analysisSampledialogVisible = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }
      }
    },

    onAddAnalysisSample(valid){
        this.submitted = true;
        if (!valid){
          return;
        }

        this.addAnalysisSample.idMovementInstructionLot = this.id;

        Service.createAnalysisSample(this.addAnalysisSample, 
          response => {
            if(response.success){
              this.loadData();
              this.addAnalysisSample = {
                idRegistryAnalysisSampleReceiver: null,
                idRegistrySamplingPoint: null,
                numberofSamples: null,
                uoMCode: null,
                quantity: null
              }
              this.submitted = false;
              this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
            }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          }
        )
       
    },
    onEditAnalysisSample(event){
        let { newData } = event;

        Service.updateAnalysisSample(newData, 
          response => {
            if(response.success){
              this.loadData();
              this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
            }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          }
        )
       
    },
    onDeleteAnalysisSample(data, event){
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('messages.delete_message_question'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          Service.deleteAnalysisSample(data.id, 
            response => {
              if(response.success){
                this.loadData();
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        },
        reject: () => {
            //callback to execute when user rejects the action
            this.$confirm.close();
        }
    });
    },
    openAnalysisSampleDialog(){
      this.analysisSampleItem = {
        idMovementInstructionLot: this.id,
        idRegistryAnalysisSampleReceiver: null,
        idRegistrySamplingPoint: null,
        numberofSamples: null,
        uoMCode: null,
        quantity: null
      }
      this.analysisSampledialogVisible = true;
    },
    openAnalysisSampleDialogEdit(data){
      this.analysisSampleItem = {...data};
      this.analysisSampledialogVisible = true;
    }
  }
}
</script>
<style scoped>
.custom-card-title{
  font-size: 18px;
}
</style>

<template>
  <main>
    <div class="grid">
      <div class="col-12">
        <div class="card">
          <div class="grid">
            <Card class="col-12" >
              <template #content>  
                <Dialog v-model:visible="analysisSampledialogVisible" modal class="p-fluid">
                  <div class="field">
                      <label :class="{'p-error':v$.analysisSampleItem.idRegistryAnalysisSampleReceiver.$invalid && submitted}">{{$t('analysisSampleReceiver.fk')}}</label>
                      <generic-custom-master-data-autocomplete-v-2
                        v-model="analysisSampleItem.idRegistryAnalysisSampleReceiver"
                        name="analysis-sample-receiver"
                        :disabled="readOnly"
                        api="masterdata/analysis-sample-receiver-combo?getOnlyValid=true"
                        :format="{ label: 'description', value: 'id' }" sortField="Description"
                        :class="{'p-invalid':v$.analysisSampleItem.idRegistryAnalysisSampleReceiver.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.analysisSampleItem.idRegistryAnalysisSampleReceiver.$invalid && submitted) || v$.analysisSampleItem.idRegistryAnalysisSampleReceiver.$pending.$response">
                          <small class="p-error" v-for="error in v$.analysisSampleItem.idRegistryAnalysisSampleReceiver.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                  <div class="field">
                      <label :class="{'p-error':v$.analysisSampleItem.idRegistrySamplingPoint.$invalid && submitted}">{{$t('samplingPoint.fk')}}</label>
                      <generic-custom-master-data-autocomplete-v-2
                        v-model="analysisSampleItem.idRegistrySamplingPoint" 
                        name="sampling-point"
                        :disabled="readOnly"
                        api="masterdata/sampling-point-combo?getOnlyValid=true"
                        :format="{ label: 'description', value: 'id' }" sortField="Description"
                        :class="{'p-invalid':v$.analysisSampleItem.idRegistrySamplingPoint.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.analysisSampleItem.idRegistrySamplingPoint.$invalid && submitted) || v$.analysisSampleItem.idRegistrySamplingPoint.$pending.$response">
                          <small class="p-error" v-for="error in v$.analysisSampleItem.idRegistrySamplingPoint.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                  <div class="field">
                      <label :class="{'p-error':v$.analysisSampleItem.numberofSamples.$invalid && submitted}">{{$t('movementInstructions.numberofSamples')}}</label>
                      <InputText
                      type="number" 
                      :disabled="readOnly"
                          v-model="analysisSampleItem.numberofSamples"
                        :class="{'p-invalid':v$.analysisSampleItem.numberofSamples.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        
                        <div v-if="(v$.analysisSampleItem.numberofSamples.$invalid && submitted) || v$.analysisSampleItem.numberofSamples.$pending.$response">
                          <small class="p-error" v-for="error in v$.analysisSampleItem.numberofSamples.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                  <div class="field">
                    <label :class="{'p-error':v$.analysisSampleItem.uoMCode.$invalid && submitted}">{{$t('unitofMeasureCode')}}</label>
                    <generic-custom-master-data-autocomplete-v-2
                      v-model="analysisSampleItem.uoMCode" 
                      :disabled="readOnly"
                      name="units-of-measure"
                      api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=MovementInstruction"
                      :format="{ label: 'code', value: 'code' }" sortField="Code"
                      :class="{'p-invalid':v$.analysisSampleItem.uoMCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        
                        <div v-if="(v$.analysisSampleItem.uoMCode.$invalid && submitted) || v$.analysisSampleItem.uoMCode.$pending.$response">
                          <small class="p-error" v-for="error in v$.analysisSampleItem.uoMCode.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                  <div class="field">
                      <label :class="{'p-error':v$.analysisSampleItem.quantity.$invalid && submitted}">{{$t('movementInstructions.quantity')}}</label>
                      <InputText
                        type="number" 
                        :disabled="readOnly"
                        v-model="analysisSampleItem.quantity"
                        :class="{'p-invalid':v$.analysisSampleItem.quantity.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.analysisSampleItem.quantity.$invalid && submitted) || v$.analysisSampleItem.quantity.$pending.$response">
                          <small class="p-error" v-for="error in v$.analysisSampleItem.quantity.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                    <template #footer>
                      <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="analysisSampledialogVisible = false"/>
                      <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSaveAnalysisSample" :disabled="analysisSampleDisabled"/>
                    </template>
                </Dialog>
                <div class="grid mt-4">
                  <div class="col-12">
                    <DataTable :value="items" showGridlines stripedRows :reorderableColumns="true">
                        <template #header>
                          <Toolbar>
                            <template #start>
                                <div class="custom-card-title">{{$t('movementInstructions.analysisSamples')}}</div>
                            </template>

                            <template #end>
                               <ResponsiveButton :label="$t('btn.add')" :disabled="!uiPermissions('MovementInstruction.Lot.AnalysisSample').isEnabled || readOnly" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openAnalysisSampleDialog"  />
                            </template>
                        </Toolbar>
                       </template>
                       
                        <Column :exportable="false" style="min-width:8rem" :reorderableColumn="false">
                          <template #body="slotProps">
                              <ResponsiveButton icon="pi pi-pencil" :disabled="!uiPermissions('MovementInstruction.Lot.AnalysisSample').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="openAnalysisSampleDialogEdit(slotProps.data)" />
                              <ResponsiveButton icon="pi pi-trash" :disabled="!uiPermissions('MovementInstruction.Lot.AnalysisSample').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDeleteAnalysisSample(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="registryAnalysisSampleReceiver" :header="$t('analysisSampleReceiver.fk')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.registryAnalysisSampleReceiver}}
                            </template>
                          <template #editor="{ data }">
                            <GenericCustomMasterDataSelect 
                              name="analysis-sample-receiver"
                              v-model="data['idRegistryAnalysisSampleReceiver']"
                              api="masterdata/analysis-sample-receiver-combo?getOnlyValid=true"
                              :format="{ label: 'description', value: 'id' }" sortField="Description"/>
                          </template>
                        </Column>
                        <Column field="registrySamplingPoint" :header="$t('samplingPoint.fk')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.registrySamplingPoint}}
                            </template>
                          <template #editor="{ data }">
                            <GenericCustomMasterDataSelect 
                              name="sampling-point"
                              v-model="data['idRegistrySamplingPoint']" 
                              api="masterdata/sampling-point-combo?getOnlyValid=true"
                              :format="{ label: 'description', value: 'id' }" sortField="Description" />
                          </template>
                        </Column>
                        <Column field="numberofSamples" :header="$t('movementInstructions.numberofSamples')" dataType="number" :sortable="true">
                            <template #body="element">
                              {{element.data.numberofSamples}}
                            </template>
                          <template #editor="{ data, field }">
                            <InputText type="number" v-model="data[field]" autofocus />
                          </template>
                        </Column>
                        <Column field="uoMCode" :header="$t('unitofMeasureCode')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.uoMCode}}
                            </template>
                          <template #editor="{ data, field }">
                            <GenericCustomMasterDataSelect :disabled="readOnly" class="w-full p-inputtext-sm mt-1 "
                              name="units-of-measure"
                              v-model="data[field]" 
                              api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=MovementInstruction"
                              :format="{label: 'code', value: 'code' }" sortField="Code" />
                          </template>
                        </Column>
                        <Column field="quantity" :header="$t('movementInstructions.quantity')" dataType="number" :sortable="true">
                            <template #body="element">
                              {{element.data.quantity}}
                            </template>
                          <template #editor="{ data, field }">
                            <InputText type="number" v-model="data[field]" autofocus />
                          </template>
                        </Column>
                        <template #empty>
                          {{$t('noRecordsFound')}}
                        </template>
                    </DataTable>
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
